export enum GTMEventCollection {
  signUpWelcome = "sign_up_welcome",
  signUpRegister = "sign_up_register",
  signUpComplete = "sign_up_complete",
}

export enum GTMEventEcommerceCollection {
  selectItem = "select_item",
  viewItem = "view_item",
  /** @deprecated */
  purchase = "purchase",
  purchase_operator = "purchase_operatore",
  addToWishlist = "add_to_wishlist",
  refund = "refund",
}
